export default {
  title: 'Settings',
  edit: {
    title: 'Edit settings'
  },
  parameters: {
    PASSWORD_EXPIRATION_DELAY: 'Password expiration delay'
  },
  success: {
    update: 'Settings updated',
    delete: 'Settings reset'
  },
  errors: {
    update: 'Unable to update settings',
    loading: 'Unable to load settings',
    delete: 'Unable to reset settings'
  },
  disabled: 'Disabled'
}
